import React, { Component } from 'react'
import moment from 'moment'
import DOMPurify from 'dompurify';

import Logo from '../common/logo'
import './landing.css'

export default class LandingPage extends Component {
  constructor(props) {
    super(props)
    this.next = this._next.bind(this)
  }

  introConditional() {
    const todayDate = moment()
    const { client, registrationOpenDate, registrationCloseDate, clientText, registrationClosedText, comingSoonText } = this.props 
    let openDate = registrationOpenDate
    let closeDate = registrationCloseDate
    let purifiedHTML = DOMPurify.sanitize(clientText, { ADD_ATTR: ['target'] });
    if (!registrationOpenDate) openDate = false
    if (!registrationCloseDate) closeDate = false
    if (closeDate && todayDate >= closeDate) {
      return (
          <div className="intro-conditional flex">
            <h2 className="intro-title">
              Let’s get personal about your health
              <br/> 
              with a plan that works for you.
            </h2>
            <h3 className="closed-title">{registrationClosedText}</h3>
            <p dangerouslySetInnerHTML={{ __html: purifiedHTML}}></p>
          </div>
        )
    }
    else if (!openDate || todayDate < openDate) {
      return (
        <div className="intro-conditional flex">
          <h2 className="intro-title">
            Let’s get personal about your health
            <br/> 
            with a plan that works for you.
          </h2>
          <h3 className="soon-title">{comingSoonText}</h3>
        </div>
      ) 
    } else {
      return (
        <div className="intro-conditional flex">
          <h2 className="intro-title">
            Let’s get personal about your health
            <br/> 
            with a plan that works for you.
          </h2>
          <p className="program-descript">
            Newtopia is offered free of charge as part of the {client} 
            <br/>
            health and well-being program. Work with your very own 
            <br/>
            Inspirator to achieve better overall mental and physical 
            <br/>
            health aligned with your unique personality and lifestyle.
          </p>
          <button data-atid="landing_next" className="button join" onClick={this.next}>SIGN UP NOW</button>
          <br/> 
          <br/>
          <p dangerouslySetInnerHTML={{ __html: purifiedHTML}}></p>
        </div>
      )
    } 
  }

  brandDisplay() {
    const { client, clientImg, clientImgText} = this.props
    let purifiedHTML = (!!clientImgText && clientImgText.trim()) ? DOMPurify.sanitize(clientImgText) : '<p>Newtopia is offered as part of the ' + client + '’s health and well-being program.</p>'
    if (!client) {
      return (
        <div className="brand-container">
        </div>
      )
    } else {
      return (
        <div className="brand-container">
          <img src={clientImg} alt="client logo" />
          <div dangerouslySetInnerHTML={{ __html: purifiedHTML}}/>
        </div>
      )
    }
  }

  _next() {
    return this.props.next()
  }

  componentDidMount() {
    var focusable = document.querySelectorAll('[tabindex]:not([tabindex="-1"])');
    focusable && focusable[0] && focusable[0].focus() 
    window.scrollTo(0, 0)
    if (window.location.hash) {
      window.location.href = window.location.hash;
    }
  }

  render() {
    const { module1ProgramText } = this.props
    const introConditional = this.introConditional()
    const brandDisplay = this.brandDisplay()
    return (
      <div>
        <div className="landing-header">
          <div>
            <Logo/>
            <div className="menu-container">
              <div className="menu-social">
                <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/newtopiahealth/">
                  <img src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/699eac18-91fd-4ab6-ab43-f79ff6e2666f.png?b=1518544011000" alt="facebook" />
                </a>
                <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/NewtopiaHealth/">
                  <img src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/909f7323-4473-4d5a-aae1-42761aa02735.png?b=1518544011000" alt="instagram" />
                </a>
              </div>
              <div className="menu-anchors">
                <a id="landing_about" href="#about">About us</a>
                <a id="landing_chatter" href="#chatter">Chatter</a>
                <a id="landing_how" href="#how">How It Works</a>
                <a id="landing_contacts" href="#contacts">Contact Us</a>
              </div>
            </div>
          </div>
        </div>

        <div className="landing-intro">
          <div className="intro-block"> 
            {introConditional}
            <img className="hero-image flex" src="https://start.newtopia.com/registration/Landing/RegistrationLandingPage-HERO_transparent.png" alt="hero image" />
          </div>
        </div>

        {brandDisplay}
        <div className="landing-component-container">
          <div id="about" name="about" className="anchor-link" />
          <div className="landing-story">
            <img className="forest-road flex" src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/f729be47-a72d-4e33-844e-03a80399bcd1.png" alt="beautiful background" />
            <div className="flex">
              <h2 className="h2-landing">
                This isn’t your traditional weight loss program.
                <br/>
                It’s so much more!
              </h2>
              <br/>
              <div>Newtopia inspires healthy habit change through personalized one-on-one coaching. You’ll learn to eat healthier, stay active, lower your stress, and lose weight to become your best self.</div>
              <br/>
              <br/>
              <div>You will be personality matched with a Newtopia Inspirator (health coach). We provide you with personalized recommendations tailored to fit your personality, lifestyle and genetic profile. {module1ProgramText}</div>
            </div>
          </div>
        </div>

        <div className="landing-component-container">
          <div id="chatter" name="chatter" className="anchor-link"/>
          <h2 className="h2-participants">What Others are Saying</h2>
          <div className="participant-containers">
            <div className="testimonial">
              <img className="participant" src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/668894bd-0bfe-45fb-8449-9e689d96f89e.png" alt="participant 1" />
              <p className="description-1">"I feel much better. My blood pressure has decreased. My medication has decreased by half. By next year I'll be off meds completely."</p>
              <p className="description-2">I chose Newtopia because I'd never done a program that had a coach, and also because of the genetic testing component. I wanted to see if it could come up with tools to reach and maintain a healthy weight. I've dieted in the past and done yo-yo dieting. I wanted to see what it would it be like to have support; would it help me maintain my weight? I'm trying to do more things in my daily life to get more steps. I park far away in the parking lot. I take the steps, not the elevator. I'm not as winded when I do a flight of stairs. I used to climb one flight, now I can climb three!</p>
              <p className="description-2">- Mary-Anne, Participant, Regional Manager</p>
            </div>
            <div className="testimonial">
              <img className="participant" src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/0d350362-353b-479e-a10d-b672cfa8ccf8.png" alt="participant 2" />
              <p className="description-1">"It's so personalized, whatever your goals are. I've learned a lot and would tell everyone to give it a try."</p>
              <p className="description-2">I have a young son who keeps me on my toes, and I wanted to be more active. I didn't think of myself as super unhealthy; I just wanted to feel better. I already enjoy being outside, and I'm not a health fanatic, but I needed to change things up a little bit. Information can be powerful, so I think the genetic piece was really helpful. Katherine's approach was great! She was very open, and just gave suggestions and ideas. Being accountable to her is part of the important piece, and the genetic aspect was important, too. I found that to be unique.</p>
              <p className="description-2">- Leslie, Participant, Head of Sales</p>
            </div>  
          </div>
          
          <div className="landing-video-container">
            <a className="video-link" target="_blank" rel="noopener noreferrer" href="https://youtu.be/cfMGYk4MXpk">
              <img className="play-button" src="https://image.s7.exacttarget.com/lib/fe9113727c60037c75/m/1/b00f7879-3fd9-4447-9fac-f03ed0831063.png" alt="video" />
              <span> Hear from more participants </span>
            </a>
          </div>
        </div>  

        <div className="landing-component-container light-grey">
          <div id="how" name="how" className="anchor-link" />
          <h2 className="h2-landing">How it works</h2>
          <div>The missing link to better health is often from not knowing enough about yourself. Join Newtopia for personalized health coaching based on your personality, lifestyle, motivation and genetic makeup!  A few quick steps will unlock your deeply personalized experience, complete with access to a personality-matched coach to support you and help you become your best self.</div>
          <div className="works-wrapper">
            <div className="works-block">
              <div className="works-item">  
                <img className="works-image" src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/c030bed6-85b7-450f-9527-bd364b4fdf5e.png" alt="clock" />
                <p className="works-description-1">Take 20 minutes to get started.</p>
                <p className="works-description-2">Tell us about yourself so we can create a program that's tailored to you and your goals.</p>
              </div>
              <div className="works-item">
                <img className="works-image" src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/db4e0afa-c2b7-4b37-a4f9-f618841e8ea5.png" alt="DNA" />
                <p className="works-description-1">Start with your genes.</p>
                <p className="works-description-2">Take an optional simple saliva test to help us understand how your genes play a role in your health.</p>
              </div>
              <div className="works-item">
                <img className="works-image" src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/9625a923-36c3-41f3-a025-74c8ae2f3f71.png" alt="inspirator"/>
                <p className="works-description-1">Meet your Inspirator.</p>
                <p className="works-description-2">Your Inspirator is your personal coach. Regular check-ins with them based on your schedule will guide and support you on your journey to a healthier lifestyle.</p>
              </div>  
            </div>
            <div className="works-block">
              <div className="works-item">
                <img className="works-image" src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/8cf60fdc-3108-4076-ba7c-8e540b60442e.png" alt="hands" />
                <p className="works-description-1">Get connected.</p>
                <p className="works-description-2">This program is tailored to your health goals to help you achieve real results. Our Inspirators and smart technology will support you every step of the way.</p> 
              </div>
              <div className="works-item">
                <img className="works-image" src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/c6729945-c7de-4b3b-b874-9a4ef90a4b26.png" alt="participants" />
                <p className="works-description-1">Find community.</p>
                <p className="works-description-2">We'll match you up with like-minded participants who are experiencing similar challenges on their own health journeys.</p>
              </div>
              <div className="works-item">
                <img className="works-image" src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/532425bd-60c3-411b-b4e1-4bc8bc1bceb3.png" alt="lift" />
                <p className="works-description-1">Become your best self.</p>
                <p className="works-description-2">Improve your overall well-being, enjoy life with increased energy, and find a support system to help maintain your goals.</p>
              </div>
            </div>
          </div>
        </div> 
      </div> 
    )
  }
}